module.exports = __webpack_public_path__ + "img/empty.c24f36b8.png";